import http from '@/biz/http.mjs'
import parseMap from '../../scripts/parseMap.mjs'
import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useModuleNode from '../_MODULE/useModuleNode.jsx'
import api from './apiFm.mjs'
import meta from './metaFm.mjs'
import Model from './ModelFm.mjs'
import PropertiesPane from './PropertiesPaneFm.jsx'
import PropertiesPaneBatch from './PropertiesPaneBatchFm.jsx'

export default () => {
    const ModuleNode = useModuleNode()

    return extendNode(ModuleNode, {
        ...meta,
        api,
        Model,
        PropertiesPane,
        PropertiesPaneBatch,

        attrNodes: {
            top: ['ATTR_FM_DESC'],
        },

        async _atOwnerPush(map, node, event) {
            const {bizNodeType} = event.target.data

            const key = {
                FA: 'archFmList',
                FM: 'child'
            }[bizNodeType]

            const d = await this._getPushData(map, node)
            event.detail[key].push(d)
        },

        _fixChild(map, node, child) {
            const {bizNodeType} = child.data

            if (/^([BD]M)$/.test(bizNodeType)) {
                this.castFrom(map, child)
                return true
            }
            else {
                return ModuleNode._fixChild.call(this, map, node, child)
            }
        },

        _getThemeColor(map, node) {
            const p = node.parent

            if (p) {
                const {bizNodeType} = p.data

                if (this.type === bizNodeType) {
                    return this._getThemeColor(map, p)
                }

                if ('CAT_DATA' === bizNodeType) {
                    return Color.CYAN
                }
            }

            return Color.GOLD
        },

        async _readGrowTree(map, node) {
            const {mapTypeCode} = map.data

            if (
                'IS_MAP' === mapTypeCode ||

                (
                    'SA_MAP' === mapTypeCode &&

                    (() => {
                        for (const n of map.trueChain(node.parent)) {
                            const {bizNodeType} = n.data

                            if (bizNodeType !== this.type) {
                                return 'CAT_DATA' === bizNodeType
                            }
                        }

                        return false
                    })()
                )
            ) {
                const {[this.mapIdProp]: mapId} = node.data
                const {mapModel} = await http.get(`/basmaps/${mapId}/IS`)
                const {root: {children}} = parseMap(mapModel)
                return {children}
            }
            else {
                return ModuleNode._readGrowTree.call(this, map, node)
            }
        },
    })
}
